import FormEditPost from "../FormEditPost";


const EditPostModal = () => {
  return (
    <FormEditPost />
  )
}

export default EditPostModal
